import React from 'react';
import './projectCostTransaction.css';
import { Outlet } from 'react-router-dom';

function ProjectCostTransaction() {
  return (
    <div>
      <Outlet></Outlet>
    </div>
  );
}

export default ProjectCostTransaction;
